<template>
  <div class="contain">
    <Navigation @changeVisible="changeVisible"></Navigation>
    <FixedContact @changeVisible="changeVisible"></FixedContact>
    <MyForm :formVisible="formVisible" @changeVisible="changeVisible"></MyForm>
    <full-page :options="options">
      <div class="section">
        <OpenWrap :scroll="scroll" @changeVisible="changeVisible" :itemShow="itemShow"></OpenWrap>
      </div>
      <div class="section">
        <CodeWhat></CodeWhat>
      </div>
      <div class="section">
        <CodePlace :scroll="scroll" :blockShow="blockShow"></CodePlace>
      </div>
      <div class="section">
        <CodeAdv @changeVisible="changeVisible" :advShow="advShow"></CodeAdv>
      </div>
      <div class="section">
        <CodeOffic @changeVisible="changeVisible" :officShow="officShow"></CodeOffic>
      </div>
      <div class="section">
        <CodeBuy @changeVisible="changeVisible" :buyShow="buyShow"></CodeBuy>
      </div>
      <div class="section">
        <CodeBusiness :busShow="busShow"></CodeBusiness>
      </div>
      <div class="section">
        <CodeCase></CodeCase>
      </div>
      <div class="section fp-auto-heigh">
        <CodeContact @changeVisible="changeVisible"></CodeContact>
      </div>
    </full-page>
  </div>
</template>
<script>
import Navigation from '@/components/Navigation'
import FixedContact from '@/components/FixedContact'
import OpenWrap from '@/components/OpenWrap'
import CodeWhat from '@/components/CodeWhat'
import CodePlace from '@/components/CodePlace'
import CodeAdv from '@/components/CodeAdv'
import CodeOffic from '@/components/CodeOffic'
import CodeBuy from '@/components/CodeBuy'
import CodeBusiness from '@/components/CodeBusiness'
import CodeCase from '@/components/CodeCase'
import CodeContact from '@/components/CodeContact'
import MyForm from '@/components/MyForm'
let timer = null
export default {
  name: 'home',
  components:{
    Navigation,
    FixedContact,
    OpenWrap,
    CodeWhat,
    CodePlace,
    CodeAdv,
    CodeOffic,
    CodeBuy,
    CodeBusiness,
    CodeCase,
    CodeContact,
    MyForm
  },
  data () {
    return {
      itemShow: false,
      blockShow: false,
      advShow: false,
      officShow: false,
      buyShow: false,
      busShow: false,
      formVisible: false,
      options: {
          licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
          afterLoad: this.afterLoad,
          onLeave: this.onLeave,
          scrollOverflow: true,
          scrollBar: false,
          paddingTop: "70px",
          // Navigation: true,
          //滚动到最顶部后是否连续滚动到底部
          // loopTop: true,
          //滚动到最底部后是否连续滚动到顶部
          // loopBottom: true,
          // continuousVertical: false,
          // menu: '#menu',
          // verticalCentered: false,
          // scrollHorizontally: true,
          // normalScrollElements: '.t-body'
          // normalScrollElements: '#element1, .element2',
          // fixedElements: ".nav",
          // navigation: true,
          // anchors: ['page1', 'page2', 'page3','page4','page5','page6','page7','page8', 'page9'],
          sectionsColor: ['#fff','#fff','#fff','#fff','#F7F6FA','#fff', '#F7F6FA', '#fff', '#fff']
      },
      scroll: 0
    }
  },
  methods: {
    afterLoad (data) {
      // index 有问题
      // console.log('----',data)
      // this.itemShow = false
      // this.blockShow = false
      // let that = this
      // clearTimeout(timer)
      // timer = setTimeout(function(){
      //   that.itemShow = true
      //   that.blockShow = true
      // }, 200)
    },
    onLeave (data) {
      this.itemShow = false
      this.blockShow = false
      this.officShow = false
      this.buyShow = false
      this.busShow = false
      this.advShow = false
      let that = this
      clearTimeout(timer)
      timer = setTimeout(function() {
        that.itemShow = true
        that.blockShow = true
        that.officShow = true
        that.buyShow = true
        that.busShow = true
        that.advShow = true
      }, 200)
      // console.log(data, '----')
    },
    scrollBar () {
      // this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(this.scroll)
    },
    changeVisible (visible) {
      this.formVisible = visible
    }
  },
  mounted () {
    // window.addEventListener('scroll', this.scrollBar)
    this.itemShow = true
  },
  created() {
    if(screen.width < 768) {
      this.$router.push({path: "/mobile"})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.fp-auto-heigh{
  height: 624px!important;
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/views/Home.vue